<template>
  <!-- <v-container fluid pa-0> -->
  <v-layout row wrap>
    <v-flex xs12 md8 v-if="!getProfileHaveClient">
      <v-card>
        <v-card-title>
          <span class="headline">Служба обмена юридически значимыми сообщениями СОЮЗ. </span>
        </v-card-title>
        <v-card-text>
          Общение в службе СОЮЗ позволяет Вам использовать вашу переписку в судах.
          Для работы в службе СОЮЗ, необходимо определить Юридическое лицо которое Вы представляете.
          Регистрируйтесь и общайтесь от имени Вашей компании.
        </v-card-text>
        <v-card-actions>
          <v-btn to="/register">Регистрация</v-btn>
          <!-- <v-btn to="/profile">Продолжить регистрацию</v-btn> -->
        </v-card-actions>   
      </v-card>
    </v-flex>
    <v-flex xs12 md8 v-if="getProfileHaveClient">
      <v-chat-list :itemId = "itemId" v-show="isRoot"></v-chat-list>
      <v-chat :itemId = "itemId" v-show="!isRoot"></v-chat>
    </v-flex>
  </v-layout>
  <!-- </v-container> -->
</template>

<script>
  import { mapGetters } from 'vuex'
  import vChatList from './ChatList.vue'
  import vChat from './Chat.vue'

  export default {
    name: 'chat-panel',
    components: {vChatList, vChat},
    props: {
    },
    data: () => ({
      itemId: null,
      isRoot: true
    }),
    mounted () {
      this.setItemId()
    },
    watch: {
    // в случае изменения маршрута запрашиваем данные вновь
      '$route' () {
        this.setItemId()
      }
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient'
      }),
      title () {
      }
    },
    methods: {
      setItemId () {
        if (this.$route.params.chatId) {
          this.itemId = this.$route.params.chatId
        } else {
          this.itemId = null
        }
        if (!(this.itemId && this.itemId !== 'root')) {
          this.isRoot = true
          this.itemId = 'root'
        } else {
          this.isRoot = false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ChatPanel.vue?150871d0